@for (message of messageConfig; let messageIndex = $index; let last = $last; track messageIndex) {
    @if (input?.errors?.[getMessageCode(message.code)]) {
        <span class="m-0 message-mat-error">
            {{ message.message }}
            @if (!last) {
                <br />
            }
        </span>
    }
}
